<ng-container>
    <div class="footer-container" #actionFooter>
        <ng-content></ng-content>
    </div>
</ng-container>